import { render, staticRenderFns } from "./appTradingRecord.vue?vue&type=template&id=72ecadcd&scoped=true&"
import script from "./appTradingRecord.vue?vue&type=script&lang=js&"
export * from "./appTradingRecord.vue?vue&type=script&lang=js&"
import style0 from "./appTradingRecord.vue?vue&type=style&index=0&id=72ecadcd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72ecadcd",
  null
  
)

export default component.exports